import { IResponse } from '@/typings/types'
import fetch from '@/utils/fetch'

import {
  IPagesParams,
  IPagesList,
  IReferralHistory,
  IRewardDetail,
  IParams,
  IStatistics,
  ISelectRightsParams,
  IShareChannels,
  ICodeParams,
  ICheckParams,
  ISingUpParams,
} from './types'

export const getShareChannels = (
  body: IParams & { sharePath: string },
  headers: any = {}
): Promise<IResponse<IShareChannels>> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/share-channels',
    data: body,
    headers,
  })
}

export const getSubsidyInfo = (
  body: IParams,
  headers: any = {}
): Promise<IResponse<IStatistics>> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/statistics',
    data: body,
    headers,
  })
}

export const selectRights = (
  body: ISelectRightsParams,
  headers: any = {}
): Promise<IResponse<boolean>> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/rights/select',
    data: body,
    headers,
  })
}

export const getRewardDetail = (
  body: IPagesParams,
  headers: any = {}
): Promise<IResponse<IPagesList<IRewardDetail>>> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/subsidy-records',
    data: body,
    headers,
  })
}

export const getReferralHistory = (
  body: IPagesParams,
  headers: any = {}
): Promise<IResponse<IPagesList<IReferralHistory>>> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/invite-records',
    data: body,
    headers,
  })
}

/* 发送邮箱验证码 */
export const getEmailCode = (body: ICodeParams, headers: any = {}): Promise<any> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/user/h5/sign-up/email/code/send',
    data: body,
    headers,
  })
}

/* 校验邮箱验证码 */
export const checkEmailCode = (body: ICheckParams, headers: any = {}): Promise<any> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/user/h5/sign-up/email/code/valid',
    data: body,
    headers,
  })
}

/* 登录/注册 */
export const singUpByEmail = (body: ISingUpParams, headers: any = {}): Promise<any> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/user/h5/sign-up/email',
    data: body,
    headers,
  })
}

/* 分享触发风控 */
export const shareInviteRisk = (body: IPagesParams, headers: any = {}): Promise<any> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/share-invite-risk',
    data: body,
    headers,
  })
}

/* 用户注册状态 */
export const displayRegisteredTips = (
  body: IParams,
  headers: any = {}
): Promise<IResponse<boolean>> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/display-registered-tips-status',
    data: body,
    headers,
  })
}

/* 获取邀请记录统计信息 */
export const inviteRecordStatistics = (
  body: IParams,
  headers: any = {}
): Promise<IResponse<any>> => {
  return fetch.post({
    url: '/api/v1/h5/adapter/oversea/marketing/h5/activity/invite-record-statistics',
    data: body,
    headers,
  })
}
